import { Link } from 'react-router-dom';
import DropdownUser from '../../components/DropdownUser';

const Header = (props: {
  sidebarOpen: string | boolean | undefined;
  setSidebarOpen: (arg0: boolean) => void;
}) => {
  return (
    <header className="sticky top-0 z-999 flex w-full bg-white drop-shadow-1  z-10">
      <div className="flex flex-grow items-center justify-between py-2 px-4 shadow-2 md:px-6 2xl:px-11">
        <div className="flex items-center gap-2 sm:gap-4 lg:hidden">
          {/* <!-- Hamburger Toggle BTN --> */}
          <button
            aria-controls="sidebar"
            onClick={(e) => {
              e.stopPropagation();
              props.setSidebarOpen(!props.sidebarOpen);
            }}
            className="z-99999 block rounded-sm  bg-white p-1.5   lg:hidden"
          ><img src='./images/burgur.png' alt="Logo" width={25}></img>
            
          </button>
          {/* <!-- Hamburger Toggle BTN --> */}

          <Link className="block flex-shrink-0 lg:hidden" to="/">
            <img src='./images/logo.png' alt="Logo" className='invert md:invert-0' /> 
          </Link>
        </div>

        <div className="flex self-end	flex-col	ml-auto pb-2	pt-2 h-13 items-center gap-3 2xsm:gap-7">
          <DropdownUser />
          
        </div>
      </div>
    </header>
  );
};

export default Header;
